export default {
  methods: {
    inputLabel(e, type, item){
      if ( type === 'filter' ) {
        item.name = e.target.value;
        this.selectedFilterItem.name = e.target.value;
        this.value.custom_filter_set.name = e.target.value;
      }
      else if ( type === 'recommend') {
        item.name = e.target.value;
        this.selectedRecommendItem.name = e.target.value;
        this.value.custom_recommend_set.name = e.target.value;
      }
    },
    // 폼 타입 선택
    clickFormType(item, type, idx) {
      if( type === 'filter' ) {
        this.selectedFilterItem.id = item.id;
        this.selectedFilterItem.name = item.name;

        if(item.id>0) {
          this.getFilterSet();
        }
      }
      else if ( type === 'recommend' ) {
        this.selectedRecommendItem.id = item.id;
        this.selectedRecommendItem.name = item.name;

        if(item.id>0) {
          this.getRecommendSet();
        }
      }
    },
    // 삭제
    deleteForm(type, index){
      if ( type === 'filter' ) {
        if ( this.selectedFilterItem.id === 0 ) {
          console.log(index)
          removeIndex(this.value.filter_set_list,index);
          return;
        }
        else {
          this.$axios.delete(this.getUrl('service/set/filter/' + this.selectedFilterItem.id)).then(res=>{
            if ( res.status === 200 ) {
              for(let i =0; i<this.value.filter_set_list.length; i++){
                if(this.value.filter_set_list[i].id === this.selectedFilterItem.id){
                  removeIndex(this.value.filter_set_list,i);
                }
              }

              this.selectedFilterItem.id=0;
              this.selectedFilterItem.name='';

              this.toast('삭제 되었습니다.');
              this.$emit('getData')
            }
          })
        }
      }
      else {
        if ( this.selectedRecommendItem.id === 0 ) {
          removeIndex(this.value.recommend_set_list,index);
          return;
        }
        else {
          this.$axios.delete(this.getUrl('service/set/recommend/' + this.selectedRecommendItem.id)).then(res=>{
            if ( res.status === 200 ) {
              for(let i =0; i<this.value.recommend_set_list.length; i++){
                if(this.value.recommend_set_list[i].id === this.selectedRecommendItem.id){
                  removeIndex(this.value.recommend_set_list,i);
                }
              }

              this.selectedRecommendItem.id = 0;
              this.selectedRecommendItem.name = ''

              this.toast('삭제 되었습니다.');
              this.$emit('getData')
            }
          })
        }
      }
    },
    // 복제
    addCopyForm(type){
      if ( type === 'filter' ) {
        this.$axios.post(this.getUrl('service/set/filter/copy'), {
          id: this.selectedFilterItem.id
        }).then(res=>{
          if( res.status === 200 ) {
            this.toast('복제되었습니다.');
            this.$emit('getData')
          }
        })
        /*this.value.filter_set_list.push({ name: '', id: 0 });
        this.selectedFilterItem.id = 0;
        this.selectedFilterItem.name = '';*/
      }
      else {
        this.$axios.post(this.getUrl('service/set/recommend/copy'), {
          id: this.selectedRecommendItem.id
        }).then(res=>{
          if( res.status === 200 ) {
            this.toast('복제되었습니다.');
            this.$emit('getData')
          }
        })
        /*this.value.recommend_set_list.push({ name: '', id: 0 });
        this.selectedRecommendItem.id = 0;
        this.selectedRecommendItem.name = '';*/
      }
    },
    mappingParamValue(item) {
      if (item.id) return item.id;
      else if (item.name) return item.name;
    },
    mappingParam(item, type) {
      //console.log(item)
      if(type==='filter'){
        if (item.param_id) return item.param_id;
        else if(item.param_name) return item.param_name;
      }
      else if(type==='recommend'){
        if (item.user.param_id) return item.user.param_id;
        else if(item.user.param_name) return item.user.param_name;
      }
    },
    isFilterTrueType(item, proditem){
      if ( item.type===proditem.type ) {
        return true
      }
      // date_range type
      else if ( item.type === 'date_range' && proditem.type==='date') {
        return true
      }
      // date_time_range type
      else if ( item.type === 'date_time_range' && proditem.type==='date' ) {
        return true
      }
      else if ( item.type === 'date_time' && proditem.type==='datetime' ) {
        return true
      }
      // 숫자범위 type
      else if ( item.type === 'integer' && proditem.type==='number_range' ) {
        return true
      }
      // 숫자범위 type
      else if ( item.type === 'number_range_input' && proditem.type==='number_range' ) {
        return true
      }
      else if ( item.type === 'time_range' && proditem.type==='time' ) {
        return true
      }
      else {
        return false
      }
    },
    // 매칭시 타입 조건 체크
    isRecommendTrueType(useritem, proditem){
      // console.log('매칭 비교',useritem, proditem)
      if ( useritem.user.type===proditem.type ) {
        return true
      }
      else if ( (useritem.user.type === 'date_range' || useritem.user.type === 'date_time_range')
        && proditem.type==='date' ) {
        return true
      }
      // 회원 디비 목록의 이름과 상품 디비의 이름이 같을 경우
      else if (useritem.user.param_name===proditem.name) {
        return true
      }
      else {
        return false
      }
    },
    deleteCustomFilterItem(index, type) {
      if ( type === 'filter' ) {
        removeIndex(this.value.custom_filter_set.data,index);
      }

      else if ( type === 'recommend' ) {
        removeIndex(this.value.custom_recommend_set.data,index);
      }
    },
    selectMatchingDB(e, item) {
      for(let i=0; i<this.targetParamList.length; i++) {
        if ((this.targetParamList[i].id && this.targetParamList[i].id.toString() === e.target.value)
          || this.targetParamList[i].name === e.target.value) {
          item.is_param = this.targetParamList[i].is_param;
          item.param_name = this.targetParamList[i].name;
          item.keyword = this.targetParamList[i].keyword;
          item.label = this.targetParamList[i].label ? this.targetParamList[i].label : this.targetParamList[i].name;

          // 맞춤DB 일 경우
          if (this.targetParamList[i].id) {
            item.param_id = this.targetParamList[i].id;
            if (Object.keys(this.targetParamList[i].options).length > 0) {
              item.options = {
                min: this.targetParamList[i].options.range.min.val,
                min_label: this.targetParamList[i].options.range.min.label,
                max: this.targetParamList[i].options.range.max.val,
                max_label: this.targetParamList[i].options.range.max.label,
                // unit: this.prodParamList[i].options.range.unit
                disabled: true
              }
            }
            if (this.targetParamList[i].unit !== null && this.targetParamList[i].unit !== '') {
              item.options.unit = this.targetParamList[i].unit;
            }
          } else {
            item.param_id = null;
            item.options = {
              min: 0,
              min_label: undefined,
              max: 1000,
              max_label: undefined,
              disabled: true
            }
            if (item.keyword === 'price__price') {
              item.options.unit = '원'
            }
          }

          break;
        }
      }
    },
    // 추천 매칭시킬 상품 DB 항목
    recommendProductMatchingDB(e, item) {
      //console.log(e.target.value);
      let value = '';
      if(isNaN(parseInt(e.target.value))) value = e.target.value;
      else value = parseInt(e.target.value);
      for(let i=0; i<this.prodParamList.length; i++){
        console.log(`prodParam_id: ${this.prodParamList[i].id} prodParam_name: ${this.prodParamList[i].name} target: ${e.target.value}`)
        if( this.prodParamList[i].id === value || this.prodParamList[i].name === value ) {
          item.is_param = this.prodParamList[i].is_param;
          item.type = this.prodParamList[i].type;
          item.keyword = this.prodParamList[i].keyword;
          item.param_name = this.prodParamList[i].name;
          if (this.prodParamList[i].id) {
            item.param_id = this.prodParamList[i].id;
          }
          item.label = this.prodParamList[i].label?this.prodParamList[i].label:this.prodParamList[i].name;
          break;
        }
      }
    },
    // 매칭시킬 회원 DB 항목
    userMatchingDB(e, item) {
      //console.log(e.target.value)
      // 매칭 상품 DB 초기화
      item.keyword = '';
      item.param_name = '';
      item.type = '';
      // console.log(this.userParamList, e.target.value)
      let value = '';
      if(isNaN(parseInt(e.target.value))) value = e.target.value;
      else value = parseInt(e.target.value);

      for(let i=0; i<this.userParamList.length; i++){
        if( this.userParamList[i].id === value ) {
          item.user.param_id = this.userParamList[i].id;
          item.user.is_param = this.userParamList[i].is_param;
          item.user.type = this.userParamList[i].type;
          item.user.keyword = this.userParamList[i].keyword;
          item.user.param_name = this.userParamList[i].name;
          break;
        }
        else if( this.userParamList[i].name === value ) {
          item.user.param_id = '';
          item.user.is_param = this.userParamList[i].is_param;
          item.user.type = this.userParamList[i].type;
          item.user.keyword = this.userParamList[i].keyword;
          item.user.param_name = this.userParamList[i].name;
          break;
        }
      }
    },
    selectFilterStyle(res, item) {
      item.type = res.input_type;
      if(item.type.indexOf('number_range')>-1) {
        item.options = {
          min: 0,
          max: 1000,
          unit: ''
        };
      }
    },
  }
}
